// generated by srcset-codegen
import src from "./logo-icon-gray.svg";

const width = 14;
const height = 15;
export default { src, width, height };
